import { connect } from 'react-redux';
import { format } from 'date-fns';

import ReportPage from '../components/ReportPage';
import { setAppRecords, setReportFilter } from '../../../actions/report';
import type { Dispatch } from '../../../type';

const DATE_FORMAT = 'yyyy-MM-dd';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    onSetReportFilter: (e, { value }) => {
        dispatch(setReportFilter(value));
    },
    onSetAppRecords: value => {
        dispatch(setAppRecords(value));
    },
});

const mapStateToProps = ({ user, report, salon, intl }) => ({
    isOwner: user.get('isOwner'),
    salon: user.get('salon'),
    fromDate: format(new Date(report.get('fromDate')), DATE_FORMAT),
    toDate: format(new Date(report.get('toDate')), DATE_FORMAT),
    showArchive: salon.get('showArchive'),
    currentLanguage: intl.get('locale') || intl.get('defaultLanguage'),
    showAppRecords: report.get('showAppRecords'),
    reportFilter: report.get('reportFilter'),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ReportPage);
